<template>
    <div class="appContainer">
        <component :is="currentComponent" />
        <app-tab v-on:onTabChange="onTapTab"/>
    </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { getUsedCarList } from '../../api'
import { mapState, mapMutations } from "vuex";
import { MessageBox } from "mint-ui";
import Cookies from "js-cookie";
import HomeComponent from '../../t13_home'
import SellComponent from '../../t13_sellCar'
import ProfileComponent from '../../t13_profile'
import AppTab from '../../t13_tab'

export default {
  components: {
    swiper,
    swiperSlide,
    HomeComponent,
    SellComponent,
    ProfileComponent,
    AppTab
  },
  props: {},
  data() {
    return {
        activeTabId: ""
    };
  },
  filters: {

  },
  watch: {},
  computed: {
      currentComponent(){
          const tabId = this.activeTabId
          switch(tabId){
              case "tab-2":
                  return "SellComponent"
              case "tab-3":
                  return "ProfileComponent"
              case "tab-1":
              default:
                  return "HomeComponent"
          }
      }
  },
  methods: {
      onTapTab(id){
          this.activeTabId = id
      }
  },
  created() {

  },
  mounted() {
    
  }
};
</script>
<style lang="scss" scoped>
    
</style>